import { ref } from 'vue'
import {
  collection,
  query,
  where,
  getDocs,
  orderBy
} from 'firebase/firestore'
import { db } from '@/firebase/firebase'

/**
 * 메인 배너 관리 Composable
 *
 * 배너 타입: admin (운영진이 등록한 배너만 사용)
 * - 파트너 배너는 더 이상 지원하지 않음
 * - Admin이 직접 배너를 등록/관리
 *
 * Firestore 컬렉션: mainBanners
 */
export function useMainBanner() {
  const loading = ref(false)
  const error = ref(null)

  /**
   * 현재 활성화된 배너 목록 조회 (홈 화면용)
   * - isActive가 true인 배너만 노출
   * - order 순서대로 정렬
   */
  const getActiveBanners = async () => {
    loading.value = true
    error.value = null

    try {
      const q = query(
        collection(db, 'mainBanners'),
        where('isActive', '==', true),
        orderBy('order', 'asc')
      )
      const snapshot = await getDocs(q)
      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
    } catch (err) {
      console.error('배너 조회 실패:', err)
      error.value = err.message
      return []
    } finally {
      loading.value = false
    }
  }

  return {
    loading,
    error,
    getActiveBanners
  }
}
